import React, { useState } from "react";
import { Footer, Navbar } from "../components";
import { WHATSAPP_PHONE } from "../config";
import { trackEvent } from "../lib/analytics";

const ContactPage = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const pageUrl = typeof window !== "undefined" ? window.location.href : "";
    const whatsappMessage = [
      "Contacto A1 Pro",
      "",
      `Nombre: ${form.name}`,
      `Email: ${form.email}`,
      `Mensaje: ${form.message || "-"}`,
      `URL: ${pageUrl}`,
    ].join("\n");
    const whatsappUrl = `https://api.whatsapp.com/send?phone=${WHATSAPP_PHONE}&text=${encodeURIComponent(
      whatsappMessage
    )}`;
    trackEvent("generate_lead", {
      source: "contact_form",
      method: "whatsapp",
    });
    window.open(whatsappUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      <Navbar />
      <div className="container my-3 py-3">
        <h1 className="text-center" data-aos="fade-up">
          Contacto
        </h1>
        <hr />
        <div className="row my-4 h-100">
          <div className="col-md-4 col-lg-4 col-sm-8 mx-auto" data-aos="fade-up">
            <form onSubmit={handleSubmit} noValidate>
              <div className="form my-3">
                <label htmlFor="name">Nombre</label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  name="name"
                  placeholder="Escribe tu nombre"
                  value={form.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form my-3">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  name="email"
                  placeholder="nombre@correo.com"
                  value={form.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form my-3">
                <label htmlFor="message">Mensaje</label>
                <textarea
                  rows={5}
                  className="form-control"
                  id="message"
                  name="message"
                  placeholder="Escribe tu mensaje"
                  value={form.message}
                  onChange={handleChange}
                />
              </div>
              <div className="text-center">
                <button className="my-2 px-4 mx-auto btn btn-whatsapp" type="submit">
                  Enviar por WhatsApp
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ContactPage;
